export function dateInDdMmYyyy(date: Date|undefined|null) {
  return date?.toLocaleDateString("de", {day: "2-digit", month: "2-digit", year: "numeric"})
}